import Vue from 'vue';
import Vuex, { MutationTree, ActionTree } from 'vuex';
import localforage from 'localforage';

Vue.use(Vuex);

interface State {
    currentLocale: string;
    currentRoutePath: string;
    isLoading: boolean;
}

const mutations: MutationTree<State> = {
    setCurrentLocale(currentState: State, currentLocale: string) {
        document.documentElement.lang = currentLocale;
        currentState.currentLocale = currentLocale;
    },
    setCurrentRoutePath(currentState: State, currentRoutePath: string) {
        currentState.currentRoutePath = currentRoutePath;
    },
    setIsLoading(currentState: State, isLoading: boolean) {
        console.log('setIsLoading:' + isLoading);
        currentState.isLoading = isLoading;
    },
    resetState() {
        // acquire initial state
        const s = initialState();
        Object.keys(s).forEach((key, i) => {
            state[i] = s[i];
        });
    },
};

const actions: ActionTree < State, any > = {};

const getters = {
    currentLocale(currentState: State) {
        return currentState.currentLocale;
    },
    currentRoutePath(currentState: State) {
        return currentState.currentRoutePath;
    },
    isLoading(currentState: State) {
        return currentState.isLoading;
    },
};

function initialState(): State {
    return {
        currentLocale: 'de',
        currentRoutePath: '/',
        isLoading: true,
    };
}

const state: State = initialState();

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
